export { default as PasswordRecoverySent } from './password-recovery-sent';
